// extracted by mini-css-extract-plugin
export default {"spinner":"Dashboard_spinner__97khr","sk-rotateplane":"Dashboard_sk-rotateplane__KAom4"};